import {
  SET_TOTAL,
  NOTIFICATION_TOTAL_REFRESH,
  INIT_FORWARD_LIST,
  NOTIFICATION_SEEN_AND_REFRESH,
} from '../../constant';

const notificationTotal = (State = 0, action = {}) => {
  const { type, data } = action;
  if (type === SET_TOTAL) {
    return data;
  }
  return State;
};

const notificationTotalRefresh = (State = 0, action = {}) => {
  const { type } = action;
  if (type === NOTIFICATION_TOTAL_REFRESH) {
    return State + 1;
  }
  return State;
};

const initForwardList = (State = [], action = {}) => {
  const { type, data } = action;
  if (type === INIT_FORWARD_LIST) {
    return data;
  }
  return State;
};

const notificationSeenAndRefresh = (State = 0, action = {}) => {
  const { type } = action;
  if (type === NOTIFICATION_SEEN_AND_REFRESH) {
    return State + 1;
  }
  return State;
};

export { notificationTotal, notificationTotalRefresh, notificationSeenAndRefresh, initForwardList };
